import React from 'react';
import { PortalOverlay, Pane } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import classnames from 'classnames';
import Pair from './Pair';
import S from './InstallGateway.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default class InstallGateway extends React.Component {
  constructor(props) {
    super(props);
    const {
      context: {
        target
      }
    } = props;
    if (target && target[0]) {
      if (target[0].type === 'desiredGateway') {
        this.targetDesiredGatewayId = target[0].id;
      }
      if (target[0].type === 'gateway') {
        this.targetGatewayId = target[0].id;
      }
    }
  }
  onChange = ({
    data,
    value,
    original
  }) => {
    this.setState({
      [data]: value
    });
    if (original) {
      if (data === 'gatewayId') {
        this.setState({
          gateway: original
        });
      } else if (data === 'desiredGatewayId') {
        this.setState({
          desiredGateway: original
        });
      } else {
        this.setState({
          [data]: original
        });
      }
    }
  };
  onPair = async () => {
    const {
      desiredGateway,
      powerSource,
      RSSI,
      placementNotes,
      floor,
      zone,
      position,
      image
    } = this.state;
    await this.removePairingsFromOldGateway();
    await this.pairNewGatewayWithDevice('desiredGateways', desiredGateway.id, false);
    await GlobalState.dispatch(this.getDesiredGatewayActions().child('gateway').update({
      data: [{
        path: 'powerSource',
        value: powerSource.value || powerSource
      }, {
        path: 'accessPoint/rssi',
        value: RSSI
      }, {
        path: 'installNotes',
        value: placementNotes
      }, {
        path: 'position',
        value: position
      }, {
        path: 'installImage',
        value: image.file.name
      }]
    }));
    await this.uploadGatewayImage();
    if (floor) {
      await this.pairNewGatewayWithDevice('floors', floor);
    }
    if (zone) {
      await this.pairNewGatewayWithDevice('zones', zone);
    }
  };
  getDesiredGatewayActions() {
    const {
      actions
    } = this.props;
    const {
      desiredGateway
    } = this.state;
    let desiredGatewayGroupActions;
    if (actions.relationship.objectType === 'desiredGateway') {
      desiredGatewayGroupActions = actions;
    } else {
      desiredGatewayGroupActions = actions.parent().child('desiredGateways');
    }
    return desiredGatewayGroupActions.itemActions(desiredGateway.id);
  }
  getLocationActions() {
    const {
      actions
    } = this.props;
    return actions.parent();
  }
  async removePairingsFromOldGateway() {
    const {
      desiredGateway
    } = this.state;
    const oldGateway = desiredGateway?.data?.gateway;
    if (oldGateway) {
      try {
        await GlobalState.dispatch(this.getLocationActions().child('gateways').itemActions(oldGateway.id).update({
          data: [{
            path: 'powerSource',
            value: null
          }, {
            path: 'accessPoint/rssi',
            value: null
          }, {
            path: 'installNotes',
            value: null
          }, {
            path: 'installImageResource',
            value: null
          }, {
            path: 'position',
            value: null
          }, {
            path: 'installImage',
            value: null
          }]
        }));
      } catch (err) {
        console.log(`Could not clean attributes on gateway ${oldGateway.id}:`, err);
        throw err;
      }

      // No need to unpair the desiredGateway and the old gateway. They will automatically
      // unpair when the new gateway pairs to the desired gateway

      const floorId = oldGateway?.data?.floor?.id;
      if (floorId) {
        await this.removeGatewayFromDevice('floors', floorId, oldGateway.id);
      }
      const zoneId = oldGateway?.data?.zone?.id;
      if (zoneId) {
        await this.removeGatewayFromDevice('zones', zoneId, oldGateway.id);
      }
    }
  }
  async removeGatewayFromDevice(deviceType, deviceId, gatewayId) {
    try {
      await GlobalState.dispatch(this.getLocationActions().child(deviceType).itemActions(deviceId).child('gateways').itemActions(gatewayId).delete());
    } catch (err) {
      console.log(`Could not remove gateway ${gatewayId} from ${deviceType} ${deviceId}:`, err);
      throw err;
    }
  }
  async pairNewGatewayWithDevice(deviceType, deviceId, oneToMany = true) {
    const gatewayPath = oneToMany ? 'gateways' : 'gateway';
    const {
      gateway
    } = this.state;
    try {
      await GlobalState.dispatch(this.getLocationActions().child(deviceType).itemActions(deviceId).createObj().obj(gatewayPath).create({
        id: gateway.id,
        force: true
      }));
    } catch (err) {
      console.log(`Could not pair gateway ${gateway.id} with ${deviceType} ${deviceId}:`, err);
      throw err;
    }
  }
  uploadGatewayImage() {
    const {
      image,
      gateway
    } = this.state;
    return GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      const nApi = this.getResourceServerFromApi(gateway, api);
      let existingResource;
      try {
        existingResource = await nApi.get();
      } catch (err) {
        console.log('Gateway install image already exists, updating', err);
      }
      if (!existingResource) {
        try {
          await nApi.create(image.file, {
            type: image.file.type
          });
        } catch (err) {
          console.log('Failed to create gateway install image', err);
        }
      } else {
        try {
          nApi.update([{
            path: 'type',
            value: image.file.type
          }], image.file);
        } catch (err) {
          console.log('Could not update gateway installation image.', err);
        }
      }
    });
  }
  getResourceServerFromApi(gateway, api) {
    const {
      systemId,
      id: gatewayId,
      data: {
        location: {
          id: locationId
        },
        company: {
          id: companyId
        }
      }
    } = gateway;
    let nApi;
    if (companyId) {
      nApi = api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).grp('gateways').obj(gatewayId).resource('resourceImage/installImage');
    } else if (locationId) {
      nApi = api.interface(systemId, 'location').obj(locationId).grp('gateways').obj(gatewayId).resource('resourceImage/installImage');
    } else {
      nApi = api.interface(systemId, 'gateway').obj(gatewayId).resource('resourceImage/installImage');
    }
    return nApi;
  }
  render() {
    const {
      actions,
      show,
      onClose,
      mobile
    } = this.props;
    return /*#__PURE__*/_jsx(PortalOverlay, {
      variant: "dialog",
      showBackground: true,
      escapeWillClose: false,
      clickWillClose: false,
      show: show,
      onClose: onClose,
      targetId: "fullScreen",
      animation: "slideFromBottom",
      position: mobile ? 'full' : 'center',
      children: /*#__PURE__*/_jsx(Pane, {
        variant: mobile ? 'pairingMobile' : 'pairing',
        className: classnames(mobile ? S.pairingContainerMobile : S.pairingContainer, S.pairing),
        children: /*#__PURE__*/_jsx(Pair, {
          ...this.props,
          onChange: this.onChange,
          actions: actions,
          ...this.state,
          targetDesiredGatewayId: this.targetDesiredGatewayId,
          targetGatewayId: this.targetGatewayId,
          titleVariant: "dialogTitle",
          gatewayNetworkId: process.env.GATEWAY_NETWORK_ID,
          onPair: this.onPair,
          onClose: onClose,
          titleIcon: "fa fa-wrench"
        })
      })
    });
  }
}